export const REMOVE_EDIT_STAY_GUEST = 'REMOVE_EDIT_STAY_GUEST'

export const removeGuest = roomGroup => ({
	type: REMOVE_EDIT_STAY_GUEST,
	payload: roomGroup
})

export default function removeEditStayGuest(roomGroup) {
	return dispatch => {
		dispatch(removeGuest(roomGroup))
	}
}



// WEBPACK FOOTER //
// ./src/actions/removeEditStayGuest.js